import errorHandlerFactory from './errorHandler';
import axios from 'axios';

const errorHandler = errorHandlerFactory('An error occured when fetching settings');

export const getUserRole = () => axios.get('/SystemInfo/GetUserRole')
    .then(r => r.data).catch(errorHandler);

export const getAppConfig = () => axios.get('/SystemInfo/AppConfig')
    .then(r => r.data).catch(errorHandler);

export const updateAppConfig = (data) => axios.put('/SystemInfo/AppConfig', data)
    .then(r => ({ status: r.status, data: r.data }));
